/**
 * Injects shopify-forms-custom.css into shopify-forms-embed#app-embed shadow root.
 * Include via: {% render 'shopify-forms-custom' %}
 */
(function () {
  var EMBED = 'shopify-forms-embed#app-embed';
  var STYLE_ID = 'lectron-forms-custom-styles';

  function injectStyles(css) {
    var embed = document.querySelector(EMBED);
    if (!embed || !embed.shadowRoot) {
      requestAnimationFrame(function () {
        injectStyles(css);
      });
      return;
    }

    var shadow = embed.shadowRoot;
    if (shadow.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    shadow.appendChild(style);
  }

  function loadCss(url) {
    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(injectStyles)
      .catch(function (error) {
        console.warn('shopify-forms-custom.css failed to load', error);
      });
  }

  var script =
    document.currentScript ||
    document.querySelector('script[src*="shopify-forms-custom.js"]');
  var cssUrl = script && (script.dataset.css || script.getAttribute('data-css'));

  if (cssUrl) loadCss(cssUrl);
})();
